export const BASE_IN_PRODUCT_PACKAGE = 1;
export const COLORANT = 2;
export const PRODUCT_GROUP = 3;
export const PRODUCT = 4;
export const BASE_IN_PRODUCT = 5;
export const COLORANT_PACKAGE = 6;
export const BUTTON = 7;
export const COLOR = 8;
export const FORMULA_COMBINATION = 9;
export const ORDER_RECORD = 10;
export const PACKAGE = 11;
export const GENERIC = 12;
export const COLOR_IN_FANDECK = 13;
export const FORMULA_NOTE = 14;
export const USER = 15;
export const CUSTOMER = 16;
export const FANDECK = 17;
export const BANNER = 18;
export const ZONE = 19;
export const FORMULA_COMBINATION_FOR_BIPP = 20;
export const COLORANT_BATCH_NUMBER = 1001;
export const UFI_CODE = 1002;
export const SERVIND_PRODUCTION_BCD = 1003;
